"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateExpertAvailabilities = exports.updateProject = exports.syncExpert = exports.rejectExpert = void 0;
var tslib_1 = require("tslib");
// @ts-nocheck
var api_1 = require("./api");
var axios_1 = tslib_1.__importDefault(require("axios"));
var tokenStorage_1 = tslib_1.__importDefault(require("./lib/tokenStorage"));
var SIXTY_SECONDS = 60000;
var axiosInstance = axios_1.default.create({
    timeout: SIXTY_SECONDS,
    baseURL: process.env.REACT_APP_GPAPI_SERVICE_URL,
    responseType: 'json',
});
axiosInstance.interceptors.request.use(function (request) {
    request.headers.Authorization = tokenStorage_1.default.get();
    return request;
});
axiosInstance.interceptors.response.use(function (response) {
    if (response.data === undefined)
        return response;
    return response.data;
}, function (error) {
    return Promise.reject(error);
});
function rejectExpert(data) {
    return axiosInstance({
        method: 'post',
        url: "/internal/v1/expert/reject",
        data: data,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.rejectExpert = rejectExpert;
function syncExpert(data) {
    return axiosInstance({
        method: 'post',
        url: "/internal/v1/expert/sync",
        data: data,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.syncExpert = syncExpert;
function updateProject(data) {
    return axiosInstance({
        method: 'post',
        url: "/internal/v1/project/update",
        data: data,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateProject = updateProject;
function updateExpertAvailabilities(data) {
    return axiosInstance({
        method: 'post',
        url: "/internal/v1/expert/update-availabilities",
        data: data,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateExpertAvailabilities = updateExpertAvailabilities;
var gpapi = {
    syncExpert: syncExpert,
    rejectExpert: rejectExpert,
};
exports.default = gpapi;
